import { Box } from '@mui/material';
import { Icon } from '@components/Icon';
import colors from '@styles/colors.module.scss';
import { Column } from '@components/Table/types';
import { VacancyResponse } from '@api/admin/adminGeneratedApi';

export const getColumns = (): Column<VacancyResponse>[] => [
  {
    title: 'Статус',
    align: 'center',
    dataIndex: 'status',
    width: '72px',
    render: (value: 'published' | 'archived') => (
      <Box display="flex" alignItems="center" justifyContent="center">
        <Icon
          name={value === 'published' ? 'check' : 'close'}
          htmlColor={value === 'published' ? colors.success : colors.error}
        />
      </Box>
    ),
  },
  {
    title: 'Город',
    dataIndex: 'area',
    sx: { whiteSpace: 'normal' },
  },
  {
    title: 'Название компании',
    dataIndex: 'company_name',
    sx: { whiteSpace: 'normal' },
  },
  {
    title: 'Название вакансии',
    dataIndex: 'name',
    sx: { whiteSpace: 'normal' },
  },
];
